module.exports = __webpack_public_path__ + "resources/img/main_banner09.0e310ad380608f29b5955d2f2c3b6e04.png";